const state = {
    produceInformationThreadFields: [
        {
            key: "item_title",
            label: "",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "qty",
            label: "數量(PCS)",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "unit_weight",
            label: "單支重(G)",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "standard_total_weight",
            label: "生產總重(KG)",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        }
    ],
    produceInformationThreadItem: [
        // {
        //     "item_title": "實際",
        //     "qty": { name: "計數器支數", count: 130190 },
        //     "unit_weight": "4.65",
        //     "standard_total_weight": "-",
        //     "unit_material_weight": "-",
        //     "material_total_weight": "-",
        // },
        // {
        //     "item_title": "標準",
        //     "qty": { name: "派工支數", count: 361600 },
        //     "unit_weight": "4.65",
        //     "standard_total_weight": "1681.44",
        //     "unit_material_weight": "4.7",
        //     "material_total_weight": "1699.52",
        // }
    ],
}
const getters = {
    get_produceInformationThreadFields: state => {
        return state.produceInformationThreadFields
    },
    get_produceInformationThreadItem: state => {
        return state.produceInformationThreadItem
    },
}
const actions = {
    set_produceInformationThreadFields(context, array) {
        context.commit('SET_PRODUCEINFORMATIONTHREADFIELDS', array);
    },
    set_produceInformationThreadItem(context, array) {
        context.commit('SET_PRODUCEINFORMATIONTHREADITEM', array);
    },
}
const mutations = {
    SET_PRODUCEINFORMATIONTHREADFIELDS(state, array) {
        state.produceInformationThreadFields = array;
    },
    SET_PRODUCEINFORMATIONTHREADITEM(state, array) {
        state.produceInformationThreadItem = array;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/produceInformationThread.js